// Generated from src/assets/Check.svg
import React, { PureComponent } from "react";

interface ISVGLayoutIconProps {
  /**
   * additional classname
   */
  // prettier-ignore
  className?: string;
  /**
   * size of the svg icon
   */
  // prettier-ignore
  size?: string | number;
  /**
   * color of the svg icon
   */
  // prettier-ignore
  fill?: string;
  /**
   * onClick event
   */
  // prettier-ignore
  onClick?: React.MouseEventHandler<SVGSVGElement>;
}

const style = {
  display: "block",
  flex: "0 0 auto",
  cursor: "pointer"
};

export default class SVGLayoutIcon extends PureComponent<
  ISVGLayoutIconProps,
  {}
> {
  render() {
    const props = this.props;
    const { size, fill } = props;
    return (
      <svg
        {...props}
        fontSize={size || 32}
        fill={fill || "currentColor"}
        style={style}
        x="0px"
        y="0px"
        width="35px"
        height="35px"
        viewBox="0 0 35 35"
        enableBackground="new 0 0 35 35"
      >
        <rect fill="#FFFFFF" width="10" height="35" />
        <g>
          <path
            fill="#FFFFFF"
            d="M34,1v33H12.438V1H34 M35,0H11.438v35H35V0L35,0z"
          />
        </g>
      </svg>
    );
  }
}
